// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { StudentRewardType } from './StudentRewardType'
import {
  StudentRewardTypeFromJSON,
  StudentRewardTypeFromJSONTyped,
  StudentRewardTypeToJSON,
} from './StudentRewardType'

/**
 *
 * @export
 * @interface StudentRewardRepresentation
 */
export interface StudentRewardRepresentation {
  /**
   *
   * @type {string}
   * @memberof StudentRewardRepresentation
   */
  rewardId: string
  /**
   *
   * @type {StudentRewardType}
   * @memberof StudentRewardRepresentation
   */
  rewardType: StudentRewardType
  /**
   *
   * @type {string}
   * @memberof StudentRewardRepresentation
   */
  activityId: string
  /**
   *
   * @type {string}
   * @memberof StudentRewardRepresentation
   */
  activityTitle: string
  /**
   *
   * @type {number}
   * @memberof StudentRewardRepresentation
   */
  coinsAwarded: number
}

/**
 * Check if a given object implements the StudentRewardRepresentation interface.
 */
export function instanceOfStudentRewardRepresentation(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'rewardId' in value
  isInstance = isInstance && 'rewardType' in value
  isInstance = isInstance && 'activityId' in value
  isInstance = isInstance && 'activityTitle' in value
  isInstance = isInstance && 'coinsAwarded' in value

  return isInstance
}

export function StudentRewardRepresentationFromJSON(
  json: any,
): StudentRewardRepresentation {
  return StudentRewardRepresentationFromJSONTyped(json, false)
}

export function StudentRewardRepresentationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): StudentRewardRepresentation {
  if (json === undefined || json === null) {
    return json
  }
  return {
    rewardId: json['rewardId'],
    rewardType: StudentRewardTypeFromJSON(json['rewardType']),
    activityId: json['activityId'],
    activityTitle: json['activityTitle'],
    coinsAwarded: json['coinsAwarded'],
  }
}

export function StudentRewardRepresentationToJSON(
  value?: StudentRewardRepresentation | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    rewardId: value.rewardId,
    rewardType: StudentRewardTypeToJSON(value.rewardType),
    activityId: value.activityId,
    activityTitle: value.activityTitle,
    coinsAwarded: value.coinsAwarded,
  }
}
